module.exports = __webpack_public_path__ + "img/preview-full-tablet.2c0ed54b.png";